/**
 * faq.js — FAQ copy for / (HOME_FAQ, spec §5.10) and /bring-me-back (BMB_FAQ, spec §6 B11).
 * Plain HTML <details>; deliberately NO FAQPage JSON-LD.
 * Shape: { id, q, a, link?: { href, label } } — `link` renders as an in-answer anchor.
 */
export const HOME_FAQ = [
  {
    id: 'kmo_free',
    q: 'Is Keep Me Out free?',
    a: 'Keep Me Out is free to download from Google Play and contains ads. Optional Premium adds unlimited schedules, up to 15 allowed apps and Location Locks.',
  },
  {
    id: 'kmo_iphone',
    q: 'Is Keep Me Out on iPhone?',
    a: 'No. Keep Me Out is Android-only (Android 6.0 or later). On iPhone, its companion app Bring Me Back adds a mindful pause before the apps you choose, and on iOS 16 or later it can block adult content in Safari and in-app browsers.',
  },
  {
    id: 'calls',
    q: 'Can I still make calls during a lock?',
    a: "Turn on emergency calling in Keep Me Out's settings and choose your contacts. Allow Usage access when the app asks — calls during a lock depend on it.",
  },
  {
    id: 'allowed',
    q: 'Can I keep using some apps while locked?',
    a: 'Yes, with Allowed Apps: 1 app on the free plan, up to 15 with Premium. It needs Usage access and notifications to work.',
  },
  {
    id: 'restart',
    q: 'What happens if I restart my phone?',
    a: "Keep Me Out has a setting to keep your phone locked after a restart, and uninstall protection adds a deliberate extra step before the app can be removed. It's designed to make cancelling on impulse hard — not to be impossible to get around.",
  },
  {
    id: 'which',
    q: 'Keep Me Out or Bring Me Back — which should I use?',
    a: 'Use Keep Me Out when you want your whole Android phone out of reach for a set time. Use Bring Me Back when you want to keep using your phone but get a moment to think before certain apps — on iPhone or Android. Bring Me Back is a separate app with its own download and its own optional Premium.',
    link: { href: '#compare', label: 'Compare them →' },
  },
];

export const BMB_FAQ = [
  {
    id: 'bmb_free',
    q: 'Is Bring Me Back free?',
    a: "It's free to download. The free plan pauses up to 3 apps with 3 pause types and blocks adult content. Premium adds unlimited apps, all 7 pause types, your own blocked sites, strict mode, history and insights, and mindful-break reminders.",
  },
  {
    id: 'bmb_iphone',
    q: 'Does it work on iPhone?',
    a: "Yes, on iOS 15.1 or later. Pauses run through an automation you set up once per app in Apple's Shortcuts app, and website blocking needs iOS 16 or later. Hard Block is Android-only.",
  },
  {
    id: 'bmb_extension',
    q: 'Is it a browser extension?',
    a: "No. Bring Me Back works on your phone. On Android it filters across apps and browsers; on iPhone it uses Apple's Screen Time filter for Safari and in-app browsers. It doesn't block sites on your computer.",
  },
  {
    id: 'bmb_part_of_kmo',
    q: 'Is Bring Me Back part of Keep Me Out?',
    a: "No. It's a separate app with its own download and its own optional Premium. Use it on its own, or alongside Keep Me Out if you're on Android.",
  },
  {
    id: 'bmb_permissions',
    q: 'Why does it ask for Accessibility or VPN permission on Android?',
    a: "Accessibility lets Bring Me Back notice when you open an app you picked, so it can pause you first. The VPN permission lets the website filter run on your phone. There's no remote VPN server, and your browsing doesn't leave the device.",
  },
  {
    id: 'bmb_bypass',
    q: 'Can I get around it?',
    a: "Yes, if you really want to: you can switch off a permission or uninstall the app. Strict mode makes it harder to turn website blocking off for a while, but Bring Me Back is about giving you a moment to choose, not a cage. For a hard lock on Android, there's Keep Me Out.",
  },
];
